import type { IValidator } from './IValidator';

export class YearValidator implements IValidator {
    status: string = '';
    statusType: 'info' | 'warning' | 'error' | 'na' = 'error';
    value?: string;
    validGenderValues: string[] = [];

    public constructor() {}
    Status(): string {
        return this.status;
    }

    StatusType(): 'info' | 'warning' | 'error' | 'na' {
        return this.statusType;
    }

    Value(): string {
        return this.value as string;
    }

    Validate(cellvalue: string): boolean {
        // Check if cellValue is a 4 digit number with regex
        if (!cellvalue.match(/^\d{4}$/)) {
            this.status = 'yearvalidator.invalidyear4digits';
            this.statusType = 'error';
            return false;
        }

        const year = parseInt(cellvalue);

        if (year < 1900 || year > new Date().getFullYear()) {
            this.status = 'yearvalidator.invalidyear';
            this.statusType = 'error';
            return false;
        }

        return true;
    }
}
